import { default as React } from "react";
import { Form } from "react-bootstrap";
import { WrappedFieldProps } from "redux-form";

interface CustomFieldProps {
  label: string;
  id: string;
  placeholder: string;
  required: boolean;
  disabled: boolean;
  type: string;
  defaultvalue: string;
  maxlength: number;
  onPaste: any;
  testId?: string;
  onKeyPress?: any
  fieldError: boolean;
  className?:string;
}
type Props = WrappedFieldProps & CustomFieldProps;

const RenderInputText = ({ label, id, input, type, placeholder, required, defaultvalue, disabled, onPaste, testId, onKeyPress, meta: { touched, error }, maxlength, fieldError,className }: Props) => {
  return (
    <Form.Group>
      {label && (
        <Form.Label className={`${fieldError ? "invalid-feedback block" : ""} block form-label`} htmlFor={id}>
          {required && <i className="fas fa-asterisk"></i>}
          {label}
        </Form.Label>
      )}
      <Form.Control className= {fieldError ? `error is-invalid ${className}` : `${className}` } {...input} data-testid={testId} id={id} maxLength={maxlength} type={type} value={defaultvalue} onPaste={onPaste} disabled={disabled} isInvalid={touched && error} placeholder={placeholder || ""}
       onKeyDown={onKeyPress} />

      {touched && error && (
        <small id="helpText" className="invalid-feedback">
          {error}
        </small>
      )}
      {fieldError && (
        <div id="helpText" className="invalid-feedback block">
          {error}
        </div>
      )}
    </Form.Group>
  );
};

export default RenderInputText;
